import React, { Component } from 'react';

class Reports extends Component {
    state = {  }
    render() { 
        return ( <div>Reports</div>  );
    }
}
 
export default Reports;